import BaseModel from "./BaseModel";
import {TyrionResourceImageType} from "../enums/TyrionResourceImageType";
import {createWebUrl} from "../functions";
import {useRuntimeConfig} from "#app";

export default class File extends BaseModel {
    private _id: number = -1;
    private _description: "";
    private _item_order: number | null = -1;
    private _size: 78828;
    private _src: string = "";
    private _title: string = "";
    private _code: string = "";
    private _format: string = "";
    private _created_at: string = "1970-01-01 00:00:01";
    private _updated_at: string = "1970-01-01 00:00:01";


    public getTyrionSrc (): string {
        const apiUrl = useRuntimeConfig().public.API_URL;
        return `${apiUrl}/api/resources/file?file=${this.src.indexOf("uploads/file") === 0 ? this.src : "remote"}&id=${this.id}`;
    }

    public downloadFileName(): string{
        return createWebUrl(this.title.replace('.' + this.format, '')) + '.' + this.format;
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get description(): "" {
        return this._description;
    }

    set description(value: "") {
        this._description = value;
    }

    get item_order(): number | null {
        return this._item_order;
    }

    set item_order(value: number | null) {
        this._item_order = value;
    }

    get size(): 78828 {
        return this._size;
    }

    set size(value: 78828) {
        this._size = value;
    }

    get src(): string {
        return this._src;
    }

    set src(value: string) {
        this._src = value;
    }

    get title(): string {
        return this._title;
    }

    set title(value: string) {
        this._title = value;
    }

    get code(): string {
        return this._code;
    }

    set code(value: string) {
        this._code = value;
    }

    get format(): string {
        return this._format;
    }

    set format(value: string) {
        this._format = value;
    }

    get created_at(): string {
        return this._created_at;
    }

    set created_at(value: string) {
        this._created_at = value;
    }

    get updated_at(): string {
        return this._updated_at;
    }

    set updated_at(value: string) {
        this._updated_at = value;
    }

}
